import Vuex from "vuex"
import Vue from "vue"
import sysIconConf from './sysIconsConf'
import mutations from './mutations'
import mapStyle from './mapStyle'
import countryStore from './countryStore'
import mapUrl from "./mapurl"
import mapStore from "./mapStore"
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        iconsConf: sysIconConf,
        controlLayers: new Map(),
        controlMaps: new Map(),
        mapUrl: mapUrl,
        fishShipList: new Map(),
        userRights: new Map(),
        userRole: new Map(),
        controlLayersName: {
            SHIP: 'SHIP_LAYER',
            GRID: 'GRID_LAYER',
            DEPTH: 'DEPTH_LAYER',
            SLEEPFISHER: 'SLEEP_FISHER_LAYER',
            ENCMAP: 'ENCMAP_LAYER',
            //撒点图层
            MARK: 'MARK_LAYERF',
            //海洋要素图层
            OCEAN: 'OCEAN_LAYERS',
            // 绿色船位点
            SHIPPOINT: "SHIP_POINT",
            // 八大渔区
            EIGHTREGION: "EIGHT_REGION",
            FAO: "FAO_LAYER",
            HisFish: "HisFish"

        },
        //兼容其他系统
        layerType: {
            //普通地图
            NMAP: 'NMAP',
            //卫星地图
            WMAP: 'WMAP',
            WMAPLABEL: 'WMAPLABEL',

            //海图
            SMAP: 'SMAP',
            //经纬度网格图层
            LLMAP: 'LLMAP',
            //经纬度网格图层
            LLMAP2: 'LLMAP2',
            //等深线图层
            DEPTHLINE: 'DEPTHLINE',
            DEPTHLINE5000: 'DEPTHLINE5000',
            //专属经济图层
            ENCMAP: 'ENCMAP',
            //船舶图层
            SHIP: 'SHIP',
            //船舶图层标注
            SHIPLABEL: 'SHIPLABEL',
            //船舶范围图层
            SHIPEXTENT: 'SHIPEXTENT',
            //船舶范围图层标注
            SHIPLABELEXTENT: 'SHIPLABELEXTENT',

            //船舶绘制图层
            SHIPDRAW: 'SHIPDRAW',
            //港口绘制图层
            SHIPORT: 'SHIPORT',
            //渔场
            FISH: 'FISH',
            RFBSIOFA: 'RFBSIOFA',
            RFBNPFC: 'RFBNPFC',

            TEMPDRAW: 'TEMPDRAW',
            SHIPTEMPDRAW: 'SHIPTEMPDRAW',
            //许慧新增
            //船舶历史轨迹时间图层标注
            HISTIME: 'HISTIME',
            //休渔区,邹娟新增
            SLEEPFISH: 'SLEEPFISH',
            //阿根廷警戒线 zoujuan
            ARGENTINASEALINE: "ARGENTINASEALINE"
        },
        oceanType: {
            //气压
            PRMSL: 'GFS_PRMSL',
            //风场
            WIND10M: 'GFS_WIND10M',
            //海浪
            WAVE: 'WW3_WAVE',
            WAVEL: 'WW3_WAVEL',
            //海面洋流
            sf: 'SHOU_sf',
            //表温
            sst: 'SHOU_sst',
            //表温线
            sstL: 'SHOU_sstL',
            //表温距平
            ssta: 'SHOU_ssta',
            //海面高度
            ssh: 'SHOU_ssh',
            //海面高度距平
            ssha: 'SHOU_ssha',
            //叶绿素
            chla: 'SHOU_chla',
            //分层洋流
            CURRENT25: 'rtofs_CURRENT25',
            //分层洋流
            CURRENT50: 'rtofs_CURRENT50',
            //分层洋流
            CURRENT100: 'rtofs_CURRENT100',
            CURRENT150: 'rtofs_CURRENT150',
            //分层洋流
            CURRENT200: 'rtofs_CURRENT200',
            //分层洋流
            CURRENT300: 'rtofs_CURRENT300',
            //分层水温
            TMP25: 'rtofs_TMP25',
            //分层水温
            TMP50: 'rtofs_TMP50',
            //分层水温
            TMP100: 'rtofs_TMP100',
            TMP150: 'rtofs_TMP150',
            //分层水温
            TMP200: 'rtofs_TMP200',
            //分层水温
            TMP300: 'rtofs_TMP300',
            //锋面预警
            fengxian: 'fengxian_fengxian',
            //风场预警
            WINDALARM: 'GFS_WINDALARM',
            //海浪预警
            WAVEALARM: 'WW3_WAVEALARM',
            //溶解氧
            do2: "do2",
            // 混合层深度
            mld: "mld",
            // 浮游生物
            phy: "phy",
            // 初级生产力
            pp: "pp"

        },
        mapLayers: new Map(),
        //当前正在使用的Map
        currentMap: null,
        vueDomPool: new Map(),
        mapStyle: mapStyle,
        countryIcons: countryStore,
        mapStore: mapStore,
        user: null,
        MMSIMap: null, //存放ship -> map映射关系
        isDarkOfHomeStyle: true  //首页是否为暗黑色
    },
    getters: {
        getVueDom: state => {
            //通过方法访问
            return state.vueDomPool
        },
        getUserId: state => {
            let user = state.user;
            if (user) {
                return user.userInfo.userId;
            }
            return "";
        }
    },
    actions: {},
    mutations: mutations,
})


// WEBPACK FOOTER //
// ./src/store/store.js